import { NavLink } from "react-router-dom";
import { useLiquity } from "src/hooks/LiquityContext";

const linkList = [
  { title: "Dashboard", path: "/" },
  { title: "Borrow", path: "/products" },
  { title: "Stability Pools", path: "/stability-pools" },
  { title: "Risky Troves", path: "/risky-troves"},
  { title: "Faucet", path: "/faucet" },
]

export const Nav: React.FC = () => {
  const { liquity: { connection } } = useLiquity()
  const assetTokenIsMock = connection._assetTokenIsMock

  return (
    <div className="md:flex flex-row text-style-sub hidden">
      {linkList.map(({ title, path }, i) => {
        if (path === "/faucet" && !assetTokenIsMock) return null
        return (
          <NavLink key={i} to={path} className={({ isActive, isPending }) => {
            const style = isActive ? "nav--active" : ""
            return `ml-6 ${style}`
          }}>
            {title}
          </NavLink>
        )
      })}
    </div>
  );
};
